import { Button, type ButtonProps, FilterListOutlinedIcon } from '@shared/components';

interface UserFilterButtonProps extends ButtonProps {
  onClick: () => void;
}
export function UserFilterButton(props: Readonly<UserFilterButtonProps>) {
  const { onClick, ...restProp } = props;
  return (
    <Button
      size='large'
      variant='outlined'
      color='secondary'
      startIcon={<FilterListOutlinedIcon />}
      onClick={onClick}
      {...restProp}
    >
      Filter
    </Button>
  );
}
